.root {
    position: relative;
    display: inline-flex;
}

.popover {
    position: absolute;
    z-index: var(--tempest-z-popover);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-lg);
    box-shadow: var(--tempest-shadow-lg);
    padding: var(--tempest-space-3) var(--tempest-space-4);
    min-width: 200px;
    max-width: 320px;
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-base);
    line-height: var(--tempest-leading-snug);
    animation: tempest-popover-in var(--tempest-duration-fast) var(--tempest-ease-out);
}

.popover:focus {
    outline: none;
}

/* Placements (center-aligned across the trigger). */
.top {
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}
.bottom {
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}
.left {
    right: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
}
.right {
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
}

@keyframes tempest-popover-in {
    from {
        opacity: 0;
        transform: translate(var(--tempest-popover-tx, -50%), 4px);
    }
    to {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .popover {
        animation: none;
    }
}
